<script setup>
import { computed, defineEmits, defineProps } from 'vue';

const props = defineProps({
    name: { type: String, default: '' },
    text: { type: String, default: '' },
    value: { type: [String, Number], default: '' },
    img: { type: String, default: '' },
    modelValue: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue']);

// Приводим к строке, чтобы не было "1" vs 1
const normalizedValue = computed(() => String(props.value));

const isChecked = computed(() => {
    const arr = Array.isArray(props.modelValue) ? props.modelValue : [];
    return arr.map(String).includes(normalizedValue.value);
});

const classes = computed(() => {
    const list = ['checkbox'];
    if (isChecked.value) list.push('_checked');
    if (props.disabled) list.push('_disabled');
    return list.join(' ');
});

const toggle = () => {
    if (props.disabled) return;

    const current = Array.isArray(props.modelValue) ? props.modelValue : [];

    let next;
    if (isChecked.value) {
        // удаляем по совпадению после нормализации
        next = current.filter((x) => String(x) !== normalizedValue.value);
    } else {
        next = [...current, props.value];
    }

    emit('update:modelValue', next);
};
</script>

<template>
    <label :class="classes">
        <span class="checkbox__inner">
          <input
              type="checkbox"
              :name="name"
              :value="value"
              :checked="isChecked"
              :disabled="disabled"
              @change="toggle"
          >

          <span v-if="img" class="checkbox__image">
              <img :src="img" alt="">
          </span>

          <span class="checkbox__text">
            <p v-html="text" />
          </span>
        </span>
    </label>
</template>
